/*import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: HelloWorld
    }
  ]
})*/

import Vue from 'vue'
import Router from 'vue-router'
import App from '../App'
import routes from './routes'

Vue.use(Router)

export default new Router({
  routes,
  mode: 'history',
  scrollBehavior (to,from,savedPosition) { //always scroll to top of page
  	return {x:0,y:0}
  }
})
